const Co2HorizontalLine = () => {
    return (
        <div className="border-top my-1 mb-3"></div>
    )
}

export default Co2HorizontalLine;